/**
 * Analytics utility for tracking user interactions.
 * Currently logs to console in development.
 * Can be extended to send events to a backend or third-party service.
 */

const isDev = process.env.NODE_ENV === 'development';

/**
 * Track an analytics event
 * @param {string} eventName - Name of the event (e.g., 'location_added')
 * @param {object} properties - Event properties
 */
export const trackEvent = (eventName, properties = {}) => {
  const event = {
    event: eventName,
    properties,
    timestamp: new Date().toISOString()
  };

  // Log to console in development
  if (isDev) {
    console.log('[Analytics]', eventName, properties);
  }

  // TODO: Send to backend analytics endpoint or third-party service
  // Example:
  // fetch('/api/analytics/track', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify(event)
  // });
};

// Location-specific tracking events
export const trackLocationAdded = (locationName, radiusMiles) => {
  trackEvent('location_added', { city: locationName, radius: radiusMiles });
};

export const trackLocationRemoved = (locationName) => {
  trackEvent('location_removed', { city: locationName });
};

export const trackLocationRadiusChanged = (locationName, oldRadius, newRadius) => {
  trackEvent('location_radius_changed', {
    city: locationName,
    old_radius: oldRadius,
    new_radius: newRadius
  });
};

export const trackLocationsClearedAll = (locationCount) => {
  trackEvent('locations_cleared_all', { count: locationCount });
};

export const trackLocationFilterToggled = (enabled, locationCount) => {
  trackEvent('location_filter_toggled', { enabled, location_count: locationCount });
};

export const trackLocationChipRemoved = (locationName, remainingCount) => {
  trackEvent('location_chip_removed', { city: locationName, remaining_count: remainingCount });
};

export const trackZeroResultsShown = (activeLocations, radiuses, filterType = 'location') => {
  trackEvent('zero_results_shown', {
    filter_type: filterType,
    active_locations: activeLocations,
    radiuses: radiuses
  });
};
